import { Reveal } from "../Reveal";

const FACTS = [
  { value: "65", label: "RV Sites" },
  { value: "30 & 50 Amp", label: "Electrical Service" },
  { value: "Full Hookups", label: "Water, Sewer and Electric" },
  { value: "Open Year-Round", label: "Short and Extended Stays" },
  { value: "Near Falcon Lake", label: "Fishing and Boating" },
] as const;

/** Quick property facts for the Rooms and Parks page. */
export function RoomsFacts() {
  return (
    <section
      className="border-y border-sand/60 bg-surface py-14 sm:py-16"
      aria-labelledby="rooms-facts-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <h2 id="rooms-facts-title" className="sr-only">
          Property facts
        </h2>
        <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-5">
          {FACTS.map((fact, i) => (
            <Reveal as="li" key={fact.value} delay={i * 0.05} y={20}>
              <div className="rule-sand pt-5 lg:border-l lg:border-sand/60 lg:pl-5 lg:pt-0 lg:first:border-l-0 lg:first:pl-0">
                <p className="font-display text-2xl leading-tight text-forest-deep sm:text-[1.55rem]">
                  {fact.value}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{fact.label}</p>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
